import React, { CSSProperties } from 'react';

import Modal from '@components/Modal/next/Modal';
import { ModalProps } from '@components/Modal/next/Modal/props';
import { CheckCircle } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';

import { Content, Label, Message } from './style';

const staticProps = {
  width: 455,
  title: null,
};

type Props = {
  onCancel?: () => void;
  message?: React.ReactNode;
  ContentComponent?:
    | React.ComponentType<React.PropsWithChildren<unknown>>
    | React.ElementType;
  contentStyle?: CSSProperties;
  renderContentMessage?: (
    message: React.ReactNode,
    children: React.ReactNode,
    MessageContainer: React.ComponentType<React.PropsWithChildren<unknown>>
  ) => React.ReactNode;
} & ModalProps;

const defaultRenderer: Props['renderContentMessage'] = (
  message,
  children,
  MessageContainer
) => (
  <>
    {message ? (
      <MessageContainer>
        <Typography variant='caption1' color='D200' weight='Regular'>
          {message}
        </Typography>
      </MessageContainer>
    ) : null}
    {children}
  </>
);

const SuccessModal = ({
  onCancel,
  title = '',
  message = '',
  ContentComponent = Content,
  contentStyle,
  children,
  renderContentMessage = defaultRenderer,
  ...rest
}: Props) => {
  return (
    <Modal
      borderRadius={8}
      zIndex={1001}
      onCancel={onCancel}
      {...staticProps}
      {...rest}
    >
      <ContentComponent style={contentStyle}>
        <CustomIcon icon={CheckCircle} fontSize={100} />
        <Label>
          <Typography variant='Title4' color='D400' weight='SemiBold'>
            {title}
          </Typography>
        </Label>
        {renderContentMessage(message, children, Message)}
      </ContentComponent>
    </Modal>
  );
};

export default SuccessModal;
